import React from 'react';

export default function Footer() {
  return (
    <div className='footer'>
      <p>KhalidMDB by Khalid Ajayi - </p>
      <a href='https://github.com/khalid-alade/KhalidMDB'>Github</a>
    </div>
  );
}
